import * as React from "react";
import { Box, Card, CardContent, Stack, Typography, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid";
import { adminFetch } from "../services/adminFetch";

function StatCard({ title }: { title: string }) {
    return (
        <Card variant="outlined" sx={{ borderRadius: 3 }}>
            <CardContent>
                <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 800 }}>
                    {title}
                </Typography>
                <Typography variant="h5" sx={{ fontWeight: 1000, mt: 1 }}>
                    <Skeleton width="55%" />
                </Typography>
                <Skeleton width="35%" />
            </CardContent>
        </Card>
    );
}

export default function DashboardPage() {

    React.useEffect(() => {
        adminFetch("/api/admin/properties?limit=1").then(async (r) => {
            console.log("props status", r.status, await r.text());
        });
    }, []);

    return (
        <Stack spacing={2.5}>
            <Box>
                <Typography variant="h5" sx={{ fontWeight: 1000 }}>
                    Dashboard
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Overview (skeleton)
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 3 }}><StatCard title="Total Properties" /></Grid>
                <Grid size={{ xs: 12, md: 3 }}><StatCard title="Upcoming Bookings" /></Grid>
                <Grid size={{ xs: 12, md: 3 }}><StatCard title="Occupancy" /></Grid>
                <Grid size={{ xs: 12, md: 3 }}><StatCard title="Avg. Night Price" /></Grid>
            </Grid>

            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 7 }}>
                    <Card variant="outlined" sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Typography sx={{ fontWeight: 1000, mb: 1.5 }}>Activity</Typography>
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                        </CardContent>
                    </Card>
                </Grid>

                <Grid size={{ xs: 12, md: 5 }}>
                    <Card variant="outlined" sx={{ borderRadius: 3 }}>
                        <CardContent>
                            <Typography sx={{ fontWeight: 1000, mb: 1.5 }}>Alerts</Typography>
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                            <Skeleton height={28} />
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </Stack>
    );
}
